import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/core";
import { Typography, Grid, Paper } from "@material-ui/core";
import Skeleton from "@material-ui/lab/Skeleton";

import { useStyles } from "./DashboardCard.css";

class DashboardCard extends Component {
  render() {
    const { classes } = this.props;
    return (
      <React.Fragment>
        <Grid
          item
          sm={4}
          xs={12}
          className={classes.gridStyle}
          onClick={() => this.props.history.push(this.props.url)}
        >
          <Paper className={classes.paper}>
            <div className={classes.titleTextStyle}>
              {this.props.label ? (
                this.props.label
              ) : (
                <Skeleton variant="text" />
              )}
            </div>
            <Typography variant="h5" className={classes.textStyle}>
              <div>
                {this.props.icon ? (
                  this.props.icon
                ) : (
                  <Skeleton variant="circle" width={40} height={40} />
                )}
              </div>
              <div className={classes.countStyle}>
                {this.props.count !== "" ? (
                  this.props.count >= 0 && this.props.count
                ) : (
                  <Skeleton variant="circle" width={40} height={40} />
                )}
              </div>
            </Typography>
          </Paper>
        </Grid>
      </React.Fragment>
    );
  }
}

export default withStyles(useStyles)(withRouter(DashboardCard));
